export default __webpack_public_path__ + "static/media/big-rupee.fe14f21f.svg";